module.exports = __webpack_public_path__ + "media/images/icon_blog02_30-30-f24cb1e2bd1112f143636b77126b47da.png";